module.exports = __webpack_public_path__ + "assets/img/station.21fbed2d.png";